export const errorMsgs = {
  email: {
    required: 'O campo e-mail é obrigatório',
    validate: 'E-mail inválido. Por favor, digite o seu e-mail corretamente',
    pattern: 'E-mail inválido. Por favor, digite o seu e-mail corretamente',
  },
  confirmEmail: {
    validate:
      'Os e-mails não conferem. Por favor, digite o seu e-mail corretamente',
    required: 'O campo confirmação do e-mail é obrigatório',
  },
  password: {
    required: 'O campo senha é obrigatório',
    validate:
      'Sua senha precisa seguir as especificações de criação, revise os dados digitados.',
    validateOnRegister: 'Formato inválido. Usar apenas letras e/ou números',
    minLength:
      'Formato inválido. Mínimo de 8 caracteres com letras, números e/ou caracteres especiais',
  },
  confirmPassword: {
    required: 'O campo confirmação de senha é obrigatório',
    validate: 'As senhas não conferem',
    minLength:
      'Formato inválido. Mínimo de 8 caracteres com letras, números e/ou caracteres especiais',
  },
  currentPassword: {
    required: 'Campo senha atual obrigatório',
    validate:
      'Formato inválido. Por favor, vá até a pagina de login e clique em esqueci minha senha',
    minLength:
      'Formato inválido. Mínimo de 8 caracteres com letras, números e/ou caracteres especiais',
  },
  newPassword: {
    required: 'Campo nova senha obrigatório',
    validate: 'Formato inválido. Usar apenas letras e/ou números',
    minLength:
      'Formato inválido. Mínimo de 8 caracteres com letras, números e/ou caracteres especiais',
  },
  confirmNewPassword: {
    required: 'Campo confirmar senha obrigatório',
    validate: 'As senhas não conferem',
    minLength:
      'Formato inválido. Mínimo de 8 caracteres com letras, números e/ou caracteres especiais',
  },
  name: {
    validate: 'Por favor, digite o seu nome completo',
    required: 'O campo nome é obrigatório',
  },
  cpf: {
    validate:
      'CPF inválido. Por favor, digite corretamente os números do seu CPF',
    required: 'O campo CPF é obrigatório',
    minLength: 'Por favor, informe um CPF válido com 11 dígitos',
  },
  cnpj: {
    validate: 'CNPJ inválido',
    minLength: 'Por favor, informe um CNPJ válido com 14 dígitos',
  },
  cellphone: {
    validate:
      'Telefone inválido. Por favor, digite corretamente apenas os números do seu celular',
    required: 'O campo celular é obrigatório',
  },
  birthdate: {
    required: 'O campo Data de nascimento é obrigatório',
    validate:
      'Data de nascimento inválida. Por favor, informe corretamente o dia, mês e ano do seu nascimento',
  },
  dueDate: {
    required: 'O campo Data de validade é obrigatório',
    validate:
      'Data de validade inválida. Por favor, informe corretamente o mês e ano da validade',
  },
  gender: {
    required: 'O campo Sexo é obrigatório',
  },
  zipcode: {
    required: 'O campo CEP é obrigatório',
  },
  street: {
    required: 'O campo Endereço é obrigatório',
  },
  number: {
    required: 'O campo Número é obrigatório',
  },
  neighborhood: {
    required: 'O campo Bairro é obrigatório',
  },
  city: {
    required: 'O campo Cidade é obrigatório',
  },
  state: {
    required: 'O campo Estado é obrigatório',
  },
  cardNumber: {
    validate:
      'Número inválido. Por favor, informe os 16 dígitos do seu cartão provisório',
    required:
      'Por favor, informe os 16 dígitos do seu cartão. Use apenas números',
    minLength: 'Por favor, informe os 16 dígitos do seu cartão',
  },
  cardNumberChangingPassword: {
    required:
      'Por favor, informe os 16 dígitos do seu cartão. Use apenas números',
    minLength: 'Por favor, informe os 16 dígitos do seu cartão',
    validate: 'Cartão não localizado.',
  },
  cvv: {
    required: 'Por favor, informe os 3 dígitos do seu CVV. Use apenas números',
    minLength: 'Por favor, informe os 3 dígitos do seu CVV',
  },
  startDate: {
    required: 'O campo Data é obrigatório',
    validate:
      'Data inválida.  Por favor, informe corretamente o dia, mês e ano',
  },
  endDate: {
    required: 'O campo Data é obrigatório',
    validate:
      'Data inválida . Por favor, informe um período menor que 140 dias',
  },
};

export default function getErrorMsg(errors, field) {
  return errorMsgs[field]?.[errors[field]?.type];
}
